import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Button, TextField, OutlinedInput, InputLabel, InputAdornment, FormControl, Checkbox, Paper, Hidden } from '@material-ui/core';
import GoogleLogo from '../../../Assets/images/google-logo.png';
import clsx from 'clsx';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';


// <--- START: Define component stlyes --->
const useStyles = makeStyles((theme) => ({
    leftBoxHiden: {
        display: 'flex',
        height: '100vh'
    },

    hiden: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },

    wrapper: {
        maxWidth: '552px',
        margin: 'auto',
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
    },

    typo: {
        marginBottom: theme.spacing(5),
    },

    userCategoryButton: {
        textTransform: 'capitalize',
        width: '46%',
        margin: 8,
        '&:hover, &:focus': {
            backgroundColor: '#47BB67',
            color: '#FFF'
        }
    },

    userCategoryContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        margin: 'auto',
        margin: '0 20px '
    },

    googleButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(4),
    },

    googleButton: {
        textTransform: 'capitalize',
        width: '90%',
        margin: 8,
        '&:hover': {
            backgroundColor: '#DD4B39',
            color: '#FFF'
        }
    },

    googleIcon: {
        width: 40,
        background: 'white',
        borderRadius: '50%',
        marginRight: theme.spacing(2),
    },

    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(2),
        width: '90%',
        margin: 8,
    },

    signUpContainer: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        margin: 'auto'
    },

    signUpButton : {
        textTransform: 'capitalize',
        width: '90%',
        margin: 8,
        '&:hover': {
            backgroundColor: '#303F9F',
            color: '#FFF'
        }
    },

    signUpButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: theme.spacing(1),
    },

    logInTypo: {
        marginLeft: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },

    termsAndConditions: {
        display: 'flex',
        justifyContent: 'flex-start',
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },

    paper: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#001524',
        height: 'inherit',
        width: '60vw',
    },

    paperTypo: {
        color: 'white',
        margin: 'auto',
    },

    link: {
        color: '#ffecd1',
        '&:hover': {
            color: '#ffecd1',
            textDecoration: 'none'
        }
    },

    signupLink: {
        color: 'black',
        '&:hover': {
            color: '#ffecd1',
            textDecoration: 'none'
        }
    }
}));
// <--- END: Define component stlyes --->

const SignUp  = () => {
const classes = useStyles();

// <--- START Email and Password Input Function ---> //

//const postForm = () => {
const [signUpDetails, setSignUpDetails] = useState({});
console.log(signUpDetails)
  
    // const onSubmit = e => {
    //   e.preventDefault()
  
    //   
const [passwordVisibility, setPasswordVisibility] = useState({showPassword: false});
console.log(passwordVisibility.showPassword)

const handleClickShowPassword = () => {
    setPasswordVisibility({ ...passwordVisibility, showPassword: !passwordVisibility.showPassword });
};

const handleMouseDownPassword = (event) => {
    event.preventDefault();
};

// <--- END Email and Password Input Function ---> //



// <--- START Checkbox Terms & Conditions Function ---> //
const [checked, setChecked] = React.useState(false);

const handleChange = (event) => {
    setChecked(event.target.checked);
};
// <--- END Checkbox Terms & Conditions Function ---> //
    
return (
    <>
        <div className={classes.leftBoxHiden}>
            <Hidden mdDown>
                <Paper square className={classes.paper}>
                    <Typography className={classes.paperTypo} variant='h1' align='center'>
                        <Link className={classes.link} to='/'>Transporex</Link>
                    </Typography>
                </Paper>
            </Hidden>
            <div className={classes.wrapper}>
                <Typography align='center' variant='h4'>
                    Welcome, thank you for choosing 
                    <Link to='/'> Transporex</Link>.
                </Typography>
                <Typography className={classes.typo} align='center' variant='h5' gutterBottom>Let's create your account!</Typography>

                <div className={classes.userCategoryContainer}>
                    <Button variant='contained' disableRipple='true' size="large" className={classes.userCategoryButton}>
                        User
                    </Button>
                    <Button variant='contained' disableRipple='true' size="large" className={classes.userCategoryButton}>
                        Transporter
                    </Button>
                </div>

                <div className={classes.googleButtonContainer}>
                    <Button variant='contained' disableRipple='true' size="medium" className={classes.googleButton}>
                        <img src={GoogleLogo} alt="google" className={classes.googleIcon} />
                            &nbsp;Sign in with Google
                    </Button>
                </div>

                <Typography className={classes.typo} align='center' variant='body1'>or use your email to create new account</Typography>

                <div className={classes.signUpContainer}>
                    <TextField
                        className={classes.textField}
                        id="Enter your first name here"
                        label="First Name"
                        placeholder="Bruce"
                        variant="outlined"
                        required
                        margin="normal"
                        value={signUpDetails.first_name}
                        onChange={(e) => setSignUpDetails({ ...signUpDetails, first_name: e.target.value })}
                        // helperText="Full width!"
                        // fullWidth
                        // InputLabelProps={{
                        //     shrink: true,
                        // }}
                    />

                    <TextField
                        className={classes.textField}
                        id="Enter your first name here"
                        label="Last Name"
                        placeholder="Lee"
                        variant="outlined"
                        required
                        margin="normal"
                        value={signUpDetails.last_name}
                        onChange={(e) => setSignUpDetails({ ...signUpDetails, last_name: e.target.value })}
                    />

                    <TextField
                        className={classes.textField}
                        id="Enter your Email address here"
                        label="Email Address"
                        placeholder="example@transporex.com"
                        variant="outlined"
                        required
                        margin="normal"
                        value={signUpDetails.email}
                        onChange={(e) => setSignUpDetails({ ...signUpDetails, email: e.target.value })}
                    />

                    <FormControl className={clsx(classes.margin, classes.textField)} variant="outlined">    
                        <InputLabel required htmlFor="user-password">Password</InputLabel>
                        <OutlinedInput
                            id="user-password"
                            type={signUpDetails.showPassword ? 'text' : 'password'}
                            value={signUpDetails.password}
                            onChange={(e) => setSignUpDetails({ ...signUpDetails, password: e.target.value })}
                            endAdornment={
                                <InputAdornment  position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    onMouseDown={handleMouseDownPassword}
                                    edge="end"
                                >
                                    {signUpDetails.showPassword ? <Visibility /> : <VisibilityOff />}
                                    </IconButton>
                                    </InputAdornment>
                            }
                            labelWidth={90}
                        />
                    </FormControl>
                </div>

                <div className={classes.termsAndConditions}>
                    <Checkbox
                        style={{padding: '0px 10px 0 5px'}}
                        required    
                        checked={checked}
                        onChange={handleChange}
                        disableRipple='true'
                        color="primary"
                        inputProps={{ 'aria-label': 'primary checkbox' }}
                    />
                    <Typography>I have read the Terms and Conditions</Typography>
                </div>

                <div className={classes.signUpButtonContainer}>
                    <Button variant='contained' disableRipple='true' size="large" className={classes.signUpButton}>
                    <Link to={'/dashboard'} className={classes.signupLink}>
                        &nbsp;Sign up
                    </Link>
                    </Button>
                </div>

                <Typography className={classes.logInTypo} gutterBottom>Already have an account?
                    <Link to='/login'> Log in</Link>
                </Typography>
            </div>
        </div>
    </>
    )
}

export default SignUp;
